import { fadeOut, fadeIn, hide, unHide, fadeOutText, fadeInText } from "./animations";

export function popupListeners() {
  document.querySelectorAll(".popup.default").forEach((popup) => {
    const popupContainer = document.getElementById(popup.id + "-container");

    document.querySelectorAll("." + popup.id + "-close").forEach((button) => {
      button.addEventListener("click", (e) => {
        fadeOut(popupContainer);
      });
    });

    document.querySelectorAll("." + popup.id + "-open").forEach((button) => {
      button.addEventListener("click", (e) => {
        fadeOut(popupContainer);
      });
    });

    popupContainer.addEventListener("click", (e) => {
      if (e.target == popupContainer) {
        fadeOut(popupContainer);
      }
    });
  });
}
